import ApiCore from "./api_core";
import { NewObs } from "./types";

export default new class {
    get(id: number) {
        return ApiCore.getJson(`observations/${id}`)
    }

    getByConceptID(patientID: number, conceptID: number) {
        return ApiCore.getJson('observations', {
            person_id: patientID,
            concept_id: conceptID
        })
    }

    create(obs: NewObs) {
        return ApiCore.postJson('observations', obs)
    }

    void(id: number) {
        return ApiCore.void(`observations/${id}`)
    }
}
